export default __webpack_public_path__ + "static/media/use_action_back4.d77bb777.png";